import { render, staticRenderFns } from "./trainingOptions.vue?vue&type=template&id=6f4456ef&scoped=true"
import script from "./trainingOptions.vue?vue&type=script&lang=js"
export * from "./trainingOptions.vue?vue&type=script&lang=js"
import style0 from "./trainingOptions.vue?vue&type=style&index=0&id=6f4456ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4456ef",
  null
  
)

export default component.exports